// extracted by mini-css-extract-plugin
export var badge = "cart-button-module--badge--fd8ad";
export var cartButton = "cart-button-module--cartButton--3acf5";